export const formatName = (...names: ReadonlyArray<string | undefined>): string => {
    return names.filter(x => x).join(' ')
}

export interface Name {
    readonly first: string
    readonly middle?: string
    readonly last: string
}
